'use client';

import { imageData } from '@/config/defaultBlur';
import { PAGE_QUERYResult } from '@/sanity.types';
import { urlForImage } from '@/sanity/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { Carousel } from 'react-bootstrap';

type splitCarouselType = Extract<
  NonNullable<NonNullable<PAGE_QUERYResult>['content']>[number],
  { _type: 'splitCarousel' }
>;

type sidesType = splitCarouselType['slides'];

type CarouselDisplayProps = {
  slides: sidesType;
  activeIndex: number;
  frame: boolean;
  onSelect: (selectedIndex: number, e?: Record<string, unknown> | null) => void;
};

export const CarouselDisplay = ({
  slides,
  activeIndex,
  onSelect,
  frame = false,
}: CarouselDisplayProps) => {
  return (
    <div className="carousel-container">
      <Carousel
        fade
        controls={slides ? slides.length > 1 : false}
        indicators={slides ? slides.length > 1 : false}
        onSelect={onSelect}
        activeIndex={activeIndex}
      >
        {slides?.map((slide, index) => {
          return (
            <Carousel.Item key={index}>
              <Link
                href={slide?.link || ''}
                className={`carousel-link ${frame ? 'frame' : ''}`}
              >
                <Image
                  src={
                    slide?.splitCarouselImage
                      ? (urlForImage(slide.splitCarouselImage)?.url() as string)
                      : ''
                  }
                  alt={slide?.splitCarouselImage?.alt || ''}
                  width={600}
                  height={600}
                  className="carousel-small-image fade-in-out"
                  placeholder="blur"
                  blurDataURL={
                    slide?.splitCarouselImage?.imgAsset?.metadata?.lqip ||
                    imageData.blurImage
                  }
                />
              </Link>
              <Carousel.Caption>
                <h4>{slide?.title}</h4>
                <p>{slide?.Description}</p>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
};
